import React, { useState } from "react";
import {
  Box,
  HStack,
  Text,
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Img,
  Circle,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import profile_icon from "../../assets/images/profile.svg";
import { useAuth } from "../Context/authContext";
import {
  LuBell,
  LuClock,
  LuUser,
  LuLogOut,
} from "react-icons/lu";

const HeaderBar = ({ LastActivity, IPAddr, ProfileIcon }) => {
  const { removeAuthData } = useAuth();

  const [notifications, setNotifications] = useState([
    { title: "Low Stock Warning!!", message: "Your 10 medicines are running low. Please restock soon.", time: "00", seen: false },
    { title: "Low Stock Warning!!", message: "Your 10 medicines are running low. Please restock soon.", time: "00", seen: null },
    { title: "Low Stock Warning!!", message: "Your 10 medicines are running low. Please restock soon.", time: "00", seen: false },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: false },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: false },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: false },
    { title: "Low Stock Warning!!", message: "Your 10 medicines are running low. Please restock soon.", time: "00", seen: false },
    { title: "Low Stock Warning!!", message: "Your 10 medicines are running low. Please restock soon.", time: "00", seen: false },
    { title: "Low Stock Warning!!", message: "Your 10 medicines are running low. Please restock soon.", time: "00", seen: false },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: true },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: false },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: true },
    { title: "New Sales Order Received", message: "You have received a new sales order.", time: "00", seen: true },
  ]);

  const hasUnreadNotifications = notifications.some((item) => !item.seen);

  const handleLogout = () => {
    localStorage.clear();
    if (removeAuthData) removeAuthData();
    window.location.replace("/");
  };

  const formattedDate =
    LastActivity ??
    new Date().toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <Box
      position="sticky"
      top="0"
      zIndex={99}
      bg="#F0F4F9"
      pt="10px"
      pb="10px"
      w="100%"
    >
      <HStack
        w="100%"
        gap="12px"
        alignItems="center"
        justifyContent="space-between"
      >
        {/* 1. Single Wide Card with Increased Height */}
        <HStack
          h="54px"
          w="100%"
          flex="1"
          px="20px"
          py="10px"
          bg="white"
          borderRadius={12}
          border="1px solid #E2E8F0"
          boxShadow="0 1px 3px rgba(0, 0, 0, 0.04)"
          alignItems="center"
          justifyContent="space-between"
        >
          <HStack spacing="10px" alignItems="center">
            <LuClock size={18} color="#64748B" />
            <Text fontSize="13.5px" fontWeight="600" color="#64748B">
              Last Login Date and Time:
            </Text>
            <Text fontSize="13.5px" fontWeight="700" color="#1E293B">
              {formattedDate}
            </Text>
          </HStack>

          <HStack
            spacing="8px"
            bg="#F0FDF4"
            border="1px solid #BBF7D0"
            px="14px"
            py="5px"
            borderRadius="full"
          >
            <Box w="7px" h="7px" borderRadius="full" bg="#16A34A" />
            <Text fontSize="12.5px" fontWeight="600" color="#15803D">
              Last Login IP: {IPAddr ?? "0.0.0.0"}
            </Text>
          </HStack>
        </HStack>

        {/* 2. Action Items: Centered Circular Bell and User Profile */}
        <HStack gap="10px" alignItems="center" flexShrink={0}>
          {/* Notifications Bell */}
          <Menu>
            <Box position="relative" w="40px" h="40px">
              <MenuButton
                as={IconButton}
                icon={<LuBell size={19} strokeWidth={2.2} />}
                w="40px"
                h="40px"
                minW="40px"
                borderRadius="full"
                bg="white"
                color="#173B70"
                border="1.5px solid #D6E0EE"
                boxShadow="0 1px 3px rgba(0, 0, 0, 0.06)"
                transition="all 0.15s ease"
                _hover={{ bg: "#F1F5F9", borderColor: "#CBD5E1" }}
                _active={{ bg: "#E2E8F0" }}
                aria-label="Notifications"
                display="flex"
                alignItems="center"
                justifyContent="center"
              />

              {/* Red Notification Dot Badge pinned directly to top-right corner of bell circle */}
              {hasUnreadNotifications && (
                <Box
                  position="absolute"
                  top="2px"
                  right="2px"
                  w="9px"
                  h="9px"
                  bg="#EF4444"
                  border="2px solid white"
                  borderRadius="full"
                  pointerEvents="none"
                  zIndex={1}
                />
              )}
            </Box>

            <MenuList maxW="320px" p="0" borderRadius="12px" overflow="hidden" zIndex={2000}>
              {/* Heading */}
              <Box px="14px" py="10px" bg="#f7f7f7" borderBottom="1px solid #ddd">
                <Text fontSize="md" fontWeight="bold">Notifications</Text>
              </Box>
              <Box maxH="250px" overflowY="auto">
                {notifications.length === 0 ? (
                  <Box p={4} textAlign="center">
                    No notifications
                  </Box>
                ) : (
                  notifications.map((n, index) => (
                    <MenuItem key={index} display="flex" alignItems="center">
                      <Box flex="1">
                        <Text fontSize="sm" fontWeight="600">{n.title}</Text>
                        <Text fontSize="xs" color="gray.600">
                          {n.message}
                        </Text>
                        <Text fontSize="10px" color="gray.400">
                          {n.time}
                        </Text>
                      </Box>

                      {/* 🔹 Seen / Unseen dot */}
                      <Circle
                        size="5px"
                        bg={n.seen ? "green.400" : "red.400"}
                        ml={2}
                        boxShadow="0 0 4px 2px rgba(0,0,0,0.3)"
                      />
                    </MenuItem>
                  ))
                )}
              </Box>
            </MenuList>
          </Menu>

          {/* Profile Avatar with Dropdown Menu */}
          <Menu>
            <MenuButton
              as={Button}
              w="40px"
              h="40px"
              minW="40px"
              p={0}
              borderRadius="full"
              border="none"
              bg="transparent"
              cursor="pointer"
              _hover={{ opacity: 0.9 }}
              _active={{ opacity: 0.8 }}
            >
              <Box
                w="40px"
                h="40px"
                borderRadius="full"
                overflow="hidden"
                border="1.5px solid #D6E0EE"
                boxShadow="0 1px 3px rgba(0, 0, 0, 0.08)"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bg="#EEF2F8"
              >
                <Img
                  w="100%"
                  h="100%"
                  src={ProfileIcon ?? profile_icon}
                  alt="Profile"
                  objectFit="cover"
                  onError={(e) => {
                    e.currentTarget.src = profile_icon;
                  }}
                />
              </Box>
            </MenuButton>

            <MenuList
              borderRadius="12px"
              border="1px solid #E2E8F0"
              boxShadow="0 10px 25px rgba(0, 0, 0, 0.1)"
              p="4px"
              minW="180px"
              zIndex={2000}
            >
              <MenuItem
                icon={<LuLogOut size={15} />}
                color="red.600"
                borderRadius="8px"
                fontSize="13px"
                py="8px"
                _hover={{ bg: "red.50" }}
                onClick={handleLogout}
              >
                Sign Out
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </HStack>
    </Box>
  );
};

export default HeaderBar;